import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { headerOffset } from "components/basic/header";
import CarChargerImage from "resources/images/CarChargerImage.png";
import HomeChargerImage from "resources/images/HomeChargerImage.png";
import Button from "components/basic/button";
import { useNavigate } from "react-router-dom";
import { ChargerEstimatorToolsPagesProps } from "pages/chargerEstimator";

const buttonStyle: React.CSSProperties = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "100%",
  height: "100%",
};

// The label has to stay readable inside a pane that is half the viewport on
// desktop but full width — and much shorter — once the panes stack.
const buttonSx = {
  fontSize: "clamp(1.5rem, 5vw, 3.5em)",
  padding: { xs: "5%", md: "10%" },
};

const ChargerLocationPage: React.FC<ChargerEstimatorToolsPagesProps> = ({
  chargerEstimatorData,
  setChargerEstimatorData,
}) => {
  const theme = useTheme();
  const { t } = useTranslation("estimator");
  const navigate = useNavigate();

  const handleSelection = (type: string) => {
    setChargerEstimatorData({
      ...chargerEstimatorData,
      installationType: type,
    });
    navigate("?currentPage=vehicleType");
  };

  return (
    <Box sx={styles.container}>
      <Box
        sx={{
          ...styles.side,
          backgroundImage: `url(${HomeChargerImage})`,
        }}
      >
        <Button
          style={{
            color: theme.palette.common.white,
            ...buttonStyle,
          }}
          sx={{ ...buttonSx, padding: { xs: "8%", md: "20%" } }}
          variant="text"
          onClick={() => handleSelection("homeowner")}
        >
          {t("location.homeowner")}
        </Button>
      </Box>

      <Box
        sx={{
          ...styles.side,
          backgroundImage: `url(${CarChargerImage})`,
        }}
      >
        <Button
          style={{
            color: theme.palette.common.white,
            ...buttonStyle,
          }}
          sx={buttonSx}
          variant="text"
          onClick={() => handleSelection("business")}
        >
          {t("location.business")}
        </Button>
      </Box>
    </Box>
  );
};

const styles = {
  container: {
    display: "flex",
    // Stacked panes each take half the screen, so the pair still fills it.
    flexDirection: { xs: "column", md: "row" },
    height: `calc(100dvh - ${headerOffset(1)})`,
  },
  side: {
    flex: 1,
    minWidth: 0,
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
  },
};

export default ChargerLocationPage;
